import { TaskModal, useProjectProfile } from '../context';

import { useTaskOption } from './options';

function ModalInner({ modal }: { modal: TaskModal }) {
  const { taskModalConfig } = useProjectProfile();

  const config = useTaskOption(modal, taskModalConfig.id);

  if (!config.isEnabled || !config.overlay) return null;

  return (
    <config.overlay
      isOpen={taskModalConfig.modal === modal}
      close={taskModalConfig.closeModal}
      task={taskModalConfig.data!}
      updateTask={config.updateTask}
    />
  );
}

export function TaskOptionModal({ taskId }: { taskId: string }) {
  const { taskModalConfig } = useProjectProfile();

  if (!taskModalConfig.modal || taskModalConfig.id !== taskId) return null;

  return <ModalInner modal={taskModalConfig.modal} />;
}
